// boardMembers.js

// Importing images for all board members
import KavitaRamjisingh from '../board/KavitaRamjisingh.jpg';
import AbheeshGupta from '../board/abheesh_gupta.jpg';
import BansariModi from '../board/bansari_modi.jpg';
import ArifBaksh from '../board/arif_baksh.jpg';
import MedhaRathore from '../board/medha_rathore.jpg';
import SharikaPillai from '../board/sharika_pillai.jpg';
import YashThakore from '../board/yash_thakore.jpg';
import SarinaPatel from '../board/sarina_patel.jpg';
import AlexPatel from '../board/alex_patel.jpg';
import HasiniDaliboyina from '../board/hasini_daliboyina.jpg';
import RutwaShah from '../board/rutwa_shah.jpg';
import KaranPatel from '../board/karan_patel.jpg';
import ShyamPatel from '../board/shyam_patel.jpg';
import JananiNagaraj from '../board/janani_nagaraj.jpg';
import KheyaRajyagorBulsara from '../board/kheya_rajyagor_bulsara.jpg';
import PrathamModi from '../board/pratham_modi.jpg';
import SimrinKhara from '../board/simrin_khara.jpg';
import NirihamShah from '../board/niriham_shah.jpg';
import PrishaPatel from '../board/prisha_patel.jpg';
import SiyaSharma from '../board/siya_sharma.jpg';
import IshikaAyyagari from '../board/ishika_ayyagari.jpg';
import VaneeshaPatel from '../board/vaneesha_patel.jpg';
import AtifAli from '../board/atif_ali.jpg';
import KarthikKappagantu from '../board/karthik_kappagantu.jpg';
import BreannePeters from '../board/breanne_peters.jpg';
import SriyaMahamkali from '../board/sriya_mahamkali.jpg';
import JanhviBilagi from '../board/janhvi_bilagi.jpg';
import ShivPatel from '../board/shiv_patel.jpg';
import NikhilKamath from '../board/nikhil_kamath.jpg';
import AbhijithPadmakumar from '../board/abhijith_padmakumar.jpg';
import AmanAliSavja from '../board/aman_ali_savja.jpg';
import NehaBilagi from '../board/neha_bilagi.jpg';
import NidhiPatel from '../board/nidhi_patel.jpg';
import KajalPatel from '../board/kajal_patel.jpg';

// Board member data
const boardMembers = [
  { name: 'Kavita Ramjisingh', title: 'Director', image: KavitaRamjisingh },
  { name: 'Abheesh Gupta', title: 'Director', image: AbheeshGupta },
  { name: 'Bansari Modi', title: 'Director', image: BansariModi },
  { name: 'Arif Baksh', title: 'Director', image: ArifBaksh },
  { name: 'Medha Rathore', title: 'Director', image: MedhaRathore },
  { name: 'Sharika Pillai', title: 'Registration Chair', image: SharikaPillai },
  { name: 'Yash Thakore', title: 'Registration Chair', image: YashThakore },
  { name: 'Sarina Patel', title: 'Hospitality Chair', image: SarinaPatel },
  { name: 'Alex Patel', title: 'Hospitality Chair', image: AlexPatel },
  { name: 'Hasini Daliboyina', title: 'Hospitality Chair', image: HasiniDaliboyina },
  { name: 'Rutwa Shah', title: 'Creative Chair', image: RutwaShah },
  { name: 'Karan Patel', title: 'Finance Chair', image: KaranPatel },
  { name: 'Shyam Patel', title: 'Finance Chair', image: ShyamPatel },
  { name: 'Janani Nagaraj', title: 'Fundraising Chair', image: JananiNagaraj },
  { name: 'Kheya Rajyagor-Bulsara', title: 'Fundraising Chair', image: KheyaRajyagorBulsara },
  { name: 'Pratham Modi', title: 'Fundraising Chair', image: PrathamModi },
  { name: 'Simrin Khara', title: 'Philanthropy Chair', image: SimrinKhara },
  { name: 'Niriham Shah', title: 'Logistics Chair', image: NirihamShah },
  { name: 'Prisha Patel', title: 'Logistics Chair', image: PrishaPatel },
  { name: 'Siya Sharma', title: 'Logistics Chair', image: SiyaSharma },
  { name: 'Ishika Ayyagari', title: 'Social Chair', image: IshikaAyyagari },
  { name: 'Vaneesha Patel', title: 'Social Chair', image: VaneeshaPatel },
  { name: 'Atif Ali', title: 'Social Chair', image: AtifAli },
  { name: 'Karthik Kappagantu', title: 'Head Liaison', image: KarthikKappagantu },
  { name: 'Breanne Peters', title: 'Show Chair', image: BreannePeters },
  { name: 'Sriya Mahamkali', title: 'Show Chair', image: SriyaMahamkali },
  { name: 'Janhvi Bilagi', title: 'Show Chair', image: JanhviBilagi },
  { name: 'Shiv Patel', title: 'Tech Chair', image: ShivPatel },
  { name: 'Nikhil Kamath', title: 'Tech Chair', image: NikhilKamath },
  { name: 'Abhijith Padmakumar', title: 'Judging Chair', image: AbhijithPadmakumar },
  { name: 'Aman Ali-Savja', title: 'Senior Advisor', image: AmanAliSavja },
  { name: 'Neha Bilagi', title: 'Senior Advisor', image: NehaBilagi },
  { name: 'Nidhi Patel', title: 'Senior Advisor', image: NidhiPatel },
  { name: 'Kajal Patel', title: 'Senior Advisor', image: KajalPatel },
];

export default boardMembers;
